import '../css/style.scss';
import Core from "./core/Core";

import Animations from "./components/Animations";
import Touch from "./components/Touch";
import SmoothScroll from "./components/SmoothScroll";
import Header from "./components/Header";
import Menu from "./components/Menu";
import Banner from "./components/Banner";
import Dropdowns from "./components/Dropdowns";
import Slideshows from "./components/Slideshows";
import GravityButtons from "./components/GravityButtons";
import Videos from "./components/Videos";
import Audios from "./components/Audios";
import Like from "./components/Like";
import Archive from "./components/Archive";
import ArticleHoverVideo from './components/ArticleHoverVideo';
import BookFormat from './components/BookFormat';
import Form from './components/Form';

document.addEventListener("DOMContentLoaded", () => {
    // Add "is-ready" class
    document.querySelector('html').classList.add('is-ready');

    // Initialization core
    Core.init();

	// Initialization components
	Animations.init();
	Touch.init();
	SmoothScroll.init();
	Header.init();
	Menu.init();
	Banner.init();
	Dropdowns.init();
	Slideshows.init();
	GravityButtons.init();
	Videos.init();
	Audios.init();
	// Like.init();
	// Archive.init();
	ArticleHoverVideo.init();
	BookFormat.init();
	Form.init();
});